// Import required modules
import apiFetch from '@wordpress/api-fetch';
// eslint-disable-next-line camelcase
import { __deprecated__recipeObject } from '@builder-legacy/common/utilities';
const { createSnackbar, isEmpty } = _uo.utility;

// Set up middleware for API fetch to include the nonce automatically in the `X-WP-Nonce` header of all requests
apiFetch.use( apiFetch.createNonceMiddleware( UncannyAutomator._site.rest.nonce ) );

/**
 * Function to perform a REST API request to update the recipe data. Handles most common errors and
 * displays a user-friendly error message.
 *
 * @param {Object} options - All the options
 * @param {String} options.endpoint - The endpoint to hit
 * @param {String} [options.method='GET'] - The HTTP request method to use (default: 'GET')
 * @param {Object} [options.data={}] - The data to be sent when using POST (default: {})
 * @param {Object} [options.snackbar={ loading: '', success: '' }] - Defines the messages to be displayed by the Snackbar (default: { loading: '', success: '' })
 * @return {Promise} - Returns a promise that resolves to the API response
 */
const builderFetch = ( {
	endpoint,
	method = 'GET',
	data = {},
	snackbar = {
		loading: '',
		success: ''
	}
} ) => {
	const hasSnackbar = ! isEmpty( snackbar.loading ) && ! isEmpty( snackbar.success );
	let $snackbar;

	if ( hasSnackbar ) {
		// Show Snackbar with loading message
		$snackbar = createSnackbar( {
			message: snackbar.loading,
			iconId: 'loading',
			iconAnimation: 'spin'
		} );
	}

	return apiFetch( {
		url: `${ UncannyAutomator._site.rest.url }/${ endpoint }`,
		method: method,
		data: data
	} )
		.then( response => {
			if ( ! isEmpty( $snackbar ) ) {
				// Update Snackbar message to success and hide it after 3 seconds
				$snackbar.message = snackbar.success;
				$snackbar.innerHTML = `<uo-icon slot="icon" id="check"></uo-icon>`;

				setTimeout( () => {
					$snackbar.remove();
				}, 3000 );
			}

			return response;
		} )
		.then( response => {
			// If new integrations data is available, update it and dispatch an event to notify UI
			if ( ! isEmpty( response._integrations ) ) {
				UncannyAutomator._integrations = JSON.parse( response._integrations );
				document.dispatchEvent( new Event( 'uap-builder-integrations-data-change' ) );
			}

			// If new recipe data is available, update it
			if ( ! isEmpty( response._recipe ) ) {
				UncannyAutomator._recipe = JSON.parse( response._recipe );
			}

			// If old recipe data is available, update it
			// @todo Remove this once the new recipe object is implemented
			if ( ! isEmpty( response.recipes_object ) ) {
				__deprecated__recipeObject( 'create', {
					allRecipes: response.recipes_object,
				} );
			}

			// If new recipe data is available, dispatch an event to notify UI
			if ( ! isEmpty( response._recipe ) ) {
				document.dispatchEvent( new Event( 'uap-builder-recipe-data-change' ) );
			}

			return response;
		} )
		.catch( error => {
			// Remove Snackbar in case of error
			if ( ! isEmpty( $snackbar ) ) {
				$snackbar.remove();
			}

			// Log the error
			// Special case logs for error codes 404 and 500
			if ( ! isEmpty( error.data ) ) {
				if ( error.data.error_code === 404 ) {
					console.log( 'Found an error 404' );
				} else if ( error.data.error_code === 500 ) {
					console.log( 'Found an error 500' );
				}
			}

			console.error( error );
		} );
}

// Export the function as default
export default builderFetch;